import React, { useEffect, useRef, useState } from 'react';
import { Swiper as SwiperStyle, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import { Swiper, Navigation } from 'swiper';
import Head from 'next/head';
import Image from 'next/image';
import Testimonials from '../components/About/Testimonials';
const componentsData = [
  {
    title: 'Our Story',
    description1:
      "Daud, the mastermind behind See Sight Tours, got his start in high school as an usher and parking lot attendant in Niagara Falls, Canada. Watching oversized tour buses shuffle tourists around with dull, cookie-cutter guides, he figured he could do better—starting with his mom's trusty minivan.",
    description2: `Armed with a freshly earned driver's license, Daud sketched out an "18-point plan" for small-group, personalized tours that showcased the real charm of the city. Battling imposter syndrome along the way, he leaned on his family's support. Before long, his tours felt less like business and more like epic trips with friends.`,
    videoUrl:
      'https://www.youtube.com/embed/-WQFXuWV69s?autoplay=1&loop=1&playlist=-WQFXuWV69s&mute=1'
  },
  {
    title: 'Why Small Groups?',
    description1:
      'Ditch the crowds and dive into a personalized, small-group tour for a more authentic, stress-free travel experience! With fewer people, every adventure feels more intimate—soak in local stories, share laughs with new friends, and explore at your own pace.',
    description2:
      "Led by passionate, expert guides, these tours go beyond the usual top five attractions, uncovering hidden gems, local hotspots, and must-see sights that bring each destination to life. Plus, by choosing small-group travel, you're supporting sustainable tourism, reducing the impact of mass tourism while fostering deeper cultural connections. Travel smarter, explore deeper, and make every moment unforgettable!",
    videoUrl:
      'https://www.youtube.com/embed/7zXo0z-vR1o?autoplay=1&mute=1&loop=1&playlist=7zXo0z-vR1o'
  },
  {
    title: 'Key Milestones',
    description1:
      "Daud's journey with See Sight Tours started with a big dream and a trusty minivan. In 2006, after weeks of pitching his guided tours downtown, his first sale happened on Canada Day—a couple took a chance, and the adventure began!",
    description2:
      "As demand for small-group travel experiences grew, he briefly dabbled in buses but quickly returned to his personalized van tours. In 2012, he went all in, even turning down law school. By 2013, See Sight Tours was TripAdvisor's #1 Niagara Falls tour, expanding to Toronto and beyond. Now, it's delivering unforgettable experiences in 20+ cities across North America!",
    videoUrl:
      'https://www.youtube.com/embed/jlmeRab2L1w?autoplay=1&mute=1&loop=1&playlist=jlmeRab2L1w'
  },
  {
    title: 'Long-Term Impact + Community Focus',
    description1:
      "From day one, we've been committed to giving back to our communities in a way that lasts. We go beyond quick donations, focusing on sustainable, long-term impact. By 2026, we're launching a dedicated community benefit fund to support local nonprofits and initiatives, ensuring our travels help more than just our guests.",
    description2:
      'Starting in Niagara Falls and expanding to every city we serve, we hire local guides, invest in communities, and promote responsible tourism. Our goal is to create a positive impact that lasts for generations—because travel should enrich destinations, not just transform them for tourists.',
    videoUrl:
      'https://www.youtube.com/embed/usxYDRAijf4?autoplay=1&mute=1&loop=1&playlist=usxYDRAijf4'
  },
  {
    title: 'The Team Behind the Tours',
    description1:
      'Our guides are the heart and soul of See Sight Tours—bringing their authentic selves and deep local knowledge to every tour. Think of them as performers, adapting the script to keep things laid-back, fun, and engaging while fostering connections between you and your fellow travelers.',
    description2:
      'We also believe in promoting from within and hiring locally. From Steven Zwygers overseeing U.S. operations to Jay Beddice leading Canadian tours, our team is built on experience and passion. Andrea Moreau keeps us organized, Brandon Mimms spreads our story, and Adam Kimmerer ensures our booking tech is just as user-friendly as our tours.',
    videoUrl:
      'https://www.youtube.com/embed/ZsRMoDTkQME?autoplay=1&mute=1&loop=1&playlist=ZsRMoDTkQME'
  },
  {
    title: 'Crafting Customer Experiences',
    description1:
      "At See Sight Tours, no two tours are ever the same. Every adventure is shaped by your guide, fellow travelers, and your own sense of wonder. We're all about crafting transformative travel experiences where each moment feels unique and memorable—not just ticking off the usual tourist spots.",
    description2:
      "While a 5-star review is our baseline, we aim for tours that leave you with a story, a local insight, or a new friendship that you'll talk about long after the journey ends. Get ready for an experience that's far more than just a sightseeing tour—it's a journey that sticks with you!",
    videoUrl:
      'https://www.youtube.com/embed/KBVxQvwnjLU?autoplay=1&mute=1&loop=1&playlist=KBVxQvwnjLU'
  },
  {
    title: 'Real Reviews, Real Connections',
    description1:
      'We started in Niagara Falls, our home base, and have since expanded to over 20 destinations across the U.S. and Canada—from New York to Texas and British Columbia to Newfoundland. Each place has its own unique heart and soul, and we want you to feel like a local by the end of your journey.',
    description2: '',
    videoUrl:
      'https://www.youtube.com/embed/lpwISuQTmr8?autoplay=1&mute=1&loop=1&playlist=lpwISuQTmr8'
  },
  {
    title: 'Explore Our Cities',
    description1:
      'We started in Niagara Falls, our home base, and have since expanded to over 20 destinations across the U.S. and Canada—from New York to Texas and British Columbia to Newfoundland. Each place has its own unique heart and soul, and we want you to feel like a local by the end of your trip.',
    description2:
      "Whether it's hidden gems or the vibrant city lights (like the changing colors of Niagara Falls at night), we've got you covered. Fun fact: we pioneered night tours in Niagara Falls, offering a whole new way to experience the city's evening magic while avoiding the daytime crowds.",
    videoUrl:
      'https://www.youtube.com/embed/tGgMpY7puV4?autoplay=1&mute=1&loop=1&playlist=tGgMpY7puV4'
  },
  {
    title: 'Our Values',
    description1:
      "At See Sight Tours, we don't just want to show you a new place—we want to transform how you experience it. Expect small-group tours that foster deeper connections and give you your guide's full attention. Respectful travel is at the core of what we do—we aim to leave every destination better than we found it, whether that means supporting local businesses or offering tours that minimize disruption.",
    description2:
      "We're not here for quick profits; our long-term focus is on creating meaningful, community-driven relationships that endure for generations, ensuring that each place we visit thrives long after your journey ends.",
    videoUrl:
      'https://www.youtube.com/embed/BKmis-JtEK0?autoplay=1&mute=1&loop=1&playlist=BKmis-JtEK0'
  },
  {
    title: 'Join Us on the Road',
    description1:
      'Ready for an unforgettable adventure? With See Sight Tours, experience the world through smaller, more intimate lenses. Our small-group tours are designed to give you a deeper connection to each destination, letting you explore like a local while avoiding the typical tourist crowds.',
    description2: `Whether you're uncovering hidden gems or immersing yourself in a city's unique culture, our tours offer an authentic, personalized experience that brings out the best in both the place and you. Book a tour today and discover how meaningful travel can change the way you see the world—one unforgettable moment at a time.`,
    videoUrl:
      'https://www.youtube.com/embed/kHLBzcVLik4?autoplay=1&mute=1&loop=1&playlist=kHLBzcVLik4'
  }
];
const VideoWithLoading = ({ videoUrl }: { videoUrl: string }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  const handleIframeLoad = () => {
    setIsIframeLoaded(true);
    setTimeout(() => setIsLoading(false), 300); // Smooth transition after iframe loads
  };

  return (
    <>
      <div
        className={`absolute top-0 left-0 w-full h-full flex items-center justify-center bg-gray-200 rounded-lg transition-opacity duration-500 ${
          isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="relative">
          {/* Pulsing play button effect */}
          <div className="absolute -inset-4 bg-white/20 rounded-full animate-pulse"></div>
          <div className="relative w-16 h-16 flex items-center justify-center rounded-full bg-white/30 backdrop-blur-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-8 h-8 text-gray-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347c-.75.412-1.667-.13-1.667-.986V5.653Z"
              />
            </svg>
          </div>
        </div>
      </div>
      <iframe
        width="100%"
        height="100%"
        src={videoUrl}
        loading="lazy"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title="YouTube video player"
        className={`absolute top-0 left-0 rounded-lg object-cover transition-opacity duration-500 ${
          isIframeLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        onLoad={handleIframeLoad}
      />
    </>
  );
};
const About = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!swiperRef.current) return;
  }, []);
  return (
    <>
      <Head>
        <meta name="og:title" content={'About Us - See Sight Tours'} />
        <meta
          name="og:description"
          content={
            'Learn about See Sight Tours, the team behind your perfect sightseeing adventure. We combine local knowledge, excellent service, and a love for travel to create memorable experiences.'
          }
        />
        <title>About Us - See Sight Tours</title>
        <meta
          name="description"
          content={
            'Learn about See Sight Tours, the team behind your perfect sightseeing adventure. We combine local knowledge, excellent service, and a love for travel to create memorable experiences.'
          }
        />
        <link
          rel="canonical"
          href={'https://www.seesight-tours.com/about-us'}
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <>
        <div className="overflow-x-hidden bg-[#e1e1e1]">
          <div className="relative w-full h-[250px] sm:h-[300px] xl:h-[400px] 2xl:h-[700px]">
            <Image
              src="/friendly-coworkers-laugh-camera-outside.png"
              alt="Friendly coworkers"
              fill
              className="object-cover object-center"
            />
            <div className="absolute bottom-0 mr-10 right-0 left-auto transform translate-y-[1rem] sm:left-0 sm:right-auto sm:translate-y-[2rem] sm:mr-10 sm:ml-6 md:ml-12 md:translate-y-[2rem] lg:ml-12 lg:translate-y-[3rem] xl:ml-20 xl:translate-y-[3rem] 2xl:translate-y-[6rem]">
              <Image
                src={'./red-triangle.svg'}
                alt="red triangle"
                width={200}
                height={210}
                className="object-contain w-[8vw] sm:w-[7vw] md:w-[8vw] lg:w-[9vw] xl:w-[10vw]"
              />
            </div>
          </div>
          {componentsData.map((item, index) => (
            <div
              key={index}
              className="w-full flex justify-center overflow-x-hidden mt-[25px] md:mt-[45px] xl:mt-[65px]"
            >
              <div className="w-[80%] mt-4 flex flex-col xl:flex-row">
                <div
                  className={`w-[100%] md:w-[90%] md:mx-auto xl:w-[50%] flex flex-row ${
                    index % 2 === 0 ? '' : ' xl:order-1 xl:justify-end '
                  }`}
                >
                  <div className="w-[16px] mt-2 sm:w-[18px] md:w-[20px] xl:w-[30px] xl:mt-4 transform -translate-x-[10px]">
                    <Image
                      src="./red-triangle-down.svg"
                      alt="red triangle"
                      width={100}
                      height={100}
                      className="object-contain"
                    />
                  </div>

                  <div className="w-[90%]">
                    <h2 className="text-[21px] md:text-[24px] xl:text-[40px] font-extrabold text-primary flex-shrink-0">
                      {item.title}
                    </h2>
                    <p className="text-[14px] md:text-[14px] xl:text-[18px] mt-3">
                      {item.description1}
                    </p>
                    <p className="text-[14px] md:text-[14px] xl:text-[18px] mt-4">
                      {item.description2}
                    </p>
                  </div>
                </div>
                <div
                  className={`w-[100%] md:w-[90%] md:mx-auto xl:w-[50%] flex flex-row mt-4 xl:mt-2 ${
                    index % 2 === 0 ? ' xl:justify-end ' : ''
                  }`}
                >
                  <div className="w-[16px] mt-2 sm:w-[18px] md:w-[20px] xl:w-[30px] xl:mt-4"></div>
                  <div
                    className="w-[90%] relative"
                    style={{ height: 0, paddingBottom: '50.7%' }}
                  >
                    <VideoWithLoading videoUrl={item.videoUrl} />
                  </div>
                </div>
              </div>
            </div>
          ))}

          <Testimonials />
        </div>
      </>
    </>
  );
};
export default About;
